<ion-card [languageRouter]="['evento', event.eventUrl]">
  <div class="event-image-container">
    <div class="category">
      {{ 'EVENT_CATEGORIES.' + event.category | uppercase | translate }}
    </div>
    <img loading="lazy" src="{{ event.data.header }}" alt="{{ event.title }}" />
  </div>

  <ion-card-content>
    <h5 class="event-title">{{ event.data.title }}</h5>
    <ion-note class="label">{{ event.shop }}</ion-note>
    <ion-card-subtitle>
      <span>{{ 'AGENDA.START' | translate }}{{ event.startDate | date: 'd/M/yy':'medium' }} |</span>
      <span>{{ 'AGENDA.END' | translate }}{{ event.endDate | date: 'd/M/yy':'medium' }}</span>
    </ion-card-subtitle>
  </ion-card-content>
</ion-card>
